import { getRequest } from "utils/helpers/common/http-methods";

export const NOTIFICATION_APIS = {

  getNotification: (params: any) => getRequest(`/admin/notifications`, params),

};
